import { ToastrService } from 'ngx-toastr';
import { SuperService } from './../../../core/services/super.service';
import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { UserService } from '../../../core/services/user.service';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { animate, style, transition, trigger } from '@angular/animations';
import { CitiesService } from '../../../core/services/cities.service';

@Component({
	selector: 'app-user-create',
	templateUrl: './user-create.component.html',
	styleUrls: ['./user-create.component.scss'],
	animations: [
		trigger('animationAlert', [
			transition(':enter', [
				style({ opacity: 0, top: '-10px' }),
				animate('.2s ease-out', style({ opacity: 1, top: 0 })),
			]),
			transition(':leave', [
				style({ opacity: 1, top: 0 }),
				animate('.2s ease-in', style({ opacity: 0, top: '-10px' })),
			]),
		]),
	],
})
export class UserCreateComponent implements OnInit {
	newUserForm: FormGroup;
	successStep: boolean;
	superUser: boolean;
	showAlert = false;
	submitted = false;
	cities = [];

	formFields = {
		name: '',
		email: '',
		organization: '',
		locale: '',
		func: '',
	};

	@Input() user?: any;

	constructor(
		public dialogRef: MatDialogRef<UserCreateComponent>,
		private toastrService: ToastrService,
		private superService: SuperService,
		private userService: UserService,
		public location: Location,
		private fb: FormBuilder,
		public router: Router,
		private citiesService: CitiesService
	) {}

	ngOnInit(): void {
		this.successStep = false;
		this.superUser = Boolean(localStorage.getItem('superUser'));

		this.citiesService.getCities().subscribe((res: any) => {
			this.cities = res;
		});

		if (this.user) {
			this.formFields = {
				name: this.user.name,
				email: this.user.email,
				organization: this.user.organization,
				locale: this.user.locale,
				func: this.user.func,
			};
			this.initPassForm();
		} else {
			this.initPassForm();
		}
	}

	initPassForm(): void {
		if (this.superUser) {
			this.newUserForm = this.fb.group({
				name: [this.formFields.name, Validators.required],
				email: [this.formFields.email, [Validators.required, Validators.email]],
				organization: [this.formFields.organization, Validators.required],
				locale: [this.formFields.locale, Validators.required],
			});
		} else {
			this.newUserForm = this.fb.group({
				name: [this.formFields.name, Validators.required],
				email: [this.formFields.email, [Validators.required, Validators.email]],
				func: [this.formFields.func, Validators.required],
			});
		}
	}

	newUser(): void {
		if (Boolean(localStorage.getItem('superUser'))) {
			const att = {
				email: this.newUserForm.value.email,
				name: this.newUserForm.value.name,
				locale: this.newUserForm.value.locale,
			};

			console.log(att);
			if (this.user) {
				att['sub'] = this.user.sub;
				this.superService.editAdmin(att).subscribe(
					(res) => {
						this.toastrService.success('Usuário alterado com sucesso.');
						this.dialogRef.close();
					},
					(error) => {
						this.toastrService.error('Algo deu errado, tente novamente.');
						this.dialogRef.close();
					}
				);
			} else {
				att['organization'] = this.newUserForm.value.organization;
				this.superService.createAdmin(att).subscribe((res) => {
					if (res === 409) {
						this.newUserForm.controls['email'].setErrors({ uniqueEmail: true });
						this.showAlert = true;
					} else {
						this.successStep = true;
						// this.newUserForm.value.email;
					}
				});
			}
		} else {
			const att = {
				email: this.newUserForm.value.email,
				'custom:role': this.newUserForm.value.func,
				name: this.newUserForm.value.name,
			};
			this.userService.createAdminUser(att).subscribe((res) => {
				if (res === 409) {
					this.newUserForm.controls['email'].setErrors({ uniqueEmail: true });
					this.showAlert = true;
				} else {
					this.successStep = true;
				}
			});
		}
	}

	redirectTo(uri: string): void {
		this.dialogRef.close();
		this.router
			.navigateByUrl('/', { skipLocationChange: true })
			.then(() => this.router.navigate([uri]));
	}

	onClose(): void {
		this.dialogRef.close();
	}

	goToAddUser(): void {
		this.successStep = false;
	}

	closeAlert(): void {
		this.showAlert = false;
	}
}
